<template>
  <div class="c-personal-wrapper">
    <!-- filter -->
    <library-filter ref="filterRef" @on-change="filterData">
      <ElButton type="primary" :loading="loading" @click="filterData">查询</ElButton>
    </library-filter>

    <!-- table  -->
    <div class="table-wrapper">
      <div class="tab-row">
        <el-tabs v-model="materialTabName">
          <el-tab-pane label="视频" :name="IMAGE_TYPES.VIDEO"></el-tab-pane>
          <el-tab-pane label="图片" :name="IMAGE_TYPES.IMAGE"></el-tab-pane>
          <el-tab-pane label="组图" :name="IMAGE_TYPES.GROUP_IMAGE"></el-tab-pane>
          <el-tab-pane label="元视频" :name="IMAGE_TYPES.META"></el-tab-pane>
          <el-tab-pane label="切片" :name="IMAGE_TYPES.SHOT"></el-tab-pane>
          <el-tab-pane label="AI混剪" :name="IMAGE_TYPES.AI_REMIX"></el-tab-pane>
          <el-tab-pane label="试玩" :name="IMAGE_TYPES.PLAYABLE"></el-tab-pane>
          <el-tab-pane label="LOGO" :name="IMAGE_TYPES.LOGO"></el-tab-pane>
          <el-tab-pane label="贴纸" :name="IMAGE_TYPES.STICKERS"></el-tab-pane>
          <el-tab-pane label="音频" :name="IMAGE_TYPES.AUDIO"></el-tab-pane>
        </el-tabs>

        <div class="table-operation-row">
          <div class="left-btns">
            <el-checkbox @change="selectAll" v-model="isCheckAll" :disabled="loading || materialData.length === 0">全选</el-checkbox>
            <el-button type="text"> 已选{{ idList.length }}个 </el-button>
            <el-button class="clear-btn" type="text" v-if="idList.length" @click="clearAll"> 清空已选 </el-button>
            <el-dropdown @command="batchAction" v-if="idList.length && Object.values(materialPermissions).some((v) => v)">
              <el-button type="text">
                &ensp;批量操作
                <i class="el-icon-arrow-down"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="BATCH_COMMANDS_ENUM.EDIT" v-if="materialPermissions.edit"> 修改素材 </el-dropdown-item>
                <el-dropdown-item :command="BATCH_COMMANDS_ENUM.REMOVE" v-if="materialPermissions.remove">删除素材</el-dropdown-item>
                <el-dropdown-item :command="BATCH_COMMANDS_ENUM.LIMIT" v-if="materialPermissions.limit"> 限制媒体投放 </el-dropdown-item>
                <el-dropdown-item :command="BATCH_COMMANDS_ENUM.REDO" v-if="materialPermissions.redo"> 重新生成 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="idList.length && materialTabName === IMAGE_TYPES.VIDEO" type="text" @click.stop="editVideoModal = true">
              批量素材处理
            </el-button>

            <template v-if="idList.length && materialTabName === IMAGE_TYPES.AI_REMIX && permissions.authAudit">
              <template v-if="remixImageType === IMAGE_TYPES.REMIX_AUDIT_PRE">
                <el-button type="text" @click="onAuditAction(IMAGE_TYPES.REMIX_AUDIT_PASS)"> 审核通过 </el-button>
                <el-button type="text" @click="onAuditAction(IMAGE_TYPES.REMIX_AUDIT_DENY)"> 审核拒绝 </el-button>
              </template>

              <template v-if="remixImageType === IMAGE_TYPES.REMIX_AUDIT_PASS">
                <el-button type="text" @click="showSentToLibModal = true"> 审核入库 </el-button>
              </template>
            </template>
          </div>
          <div class="right-btns">
            <template v-if="permissions.authImportDownload">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">
                  该功能用于素材的属性<br />（游戏、设计师、素材标签等）<br />的批量绑定。<br />
                  点击此处 <el-button type="text" @click="downExcel">下载模板</el-button>
                </div>
                <span class="template-download-icon el-icon-question"></span>
              </el-tooltip>

              <el-upload action="" :before-upload="preUpload" accept="application/vnd.ms-excel,.xls,.xlsx,.csv">
                <el-button style="margin-right: 3px" ghost>属性绑定导入</el-button>
              </el-upload>
              <template v-if="listType">
                <CustomColumnDropdownBtn
                  ref="tableCustomColsRef"
                  name="LibTableCustomColumn"
                  menu-id="M20850"
                  :col-list="defaultTableCols"
                  :navs="defaultTableColNavs"
                  @change="onTableColsChange"
                ></CustomColumnDropdownBtn>
              </template>
            </template>

            <em class="toggle-view-btn" :class="{ active: !listType }" title="宫格显示" @click="changeList">
              <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22">
                <path
                  d="M475.09702 413.787164c0 40.939411-33.497928 74.437339-74.437339 74.437339L136.096143 488.224504c-40.940434 0-74.437339-33.497928-74.437339-74.437339L61.658803 137.960095c0-40.939411 33.495882-74.437339 74.437339-74.437339l264.565585 0c40.939411 0 74.437339 33.496905 74.437339 74.437339L475.09702 413.787164 475.09702 413.787164z"
                  fill="#fff"
                ></path>
                <path
                  d="M475.09702 886.052185c0 40.940434-33.497928 74.435293-74.437339 74.435293L136.096143 960.487477c-40.940434 0-74.437339-33.494858-74.437339-74.435293l0-275.821953c0-40.940434 33.495882-74.435293 74.437339-74.435293l264.565585 0c40.939411 0 74.437339 33.495882 74.437339 74.435293L475.09702 886.052185 475.09702 886.052185z"
                  fill="#fff"
                ></path>
                <path
                  d="M958.619432 413.787164c0 40.939411-33.495882 74.437339-74.437339 74.437339L619.603205 488.224504c-40.942481 0-74.436316-33.497928-74.436316-74.437339L545.166889 137.960095c0-40.939411 33.495882-74.437339 74.436316-74.437339l264.580934 0c40.940434 0 74.436316 33.496905 74.436316 74.437339L958.619432 413.787164z"
                  fill="#fff"
                ></path>
                <path
                  d="M958.623525 886.052185c0 40.940434-33.497928 74.435293-74.437339 74.435293L619.604228 960.487477c-40.941458 0-74.436316-33.494858-74.436316-74.435293l0-275.821953c0-40.940434 33.495882-74.435293 74.436316-74.435293l264.581957 0c40.940434 0 74.437339 33.495882 74.437339 74.435293L958.623525 886.052185z"
                  fill="#fff"
                ></path>
              </svg>
            </em>
            <em class="toggle-view-btn" :class="{ active: listType }" title="表格显示" @click="changeList">
              <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22">
                <path
                  fill="#fff"
                  d="M187.392 70.656q28.672 0 48.64 19.456t19.968 48.128l0 52.224q0 28.672-19.968 48.64t-48.64 19.968l-54.272 0q-27.648 0-47.616-19.968t-19.968-48.64l0-52.224q0-28.672 19.968-48.128t47.616-19.456l54.272 0zM889.856 70.656q27.648 0 47.616 19.456t19.968 48.128l0 52.224q0 28.672-19.968 48.64t-47.616 19.968l-437.248 0q-28.672 0-48.64-19.968t-19.968-48.64l0-52.224q0-28.672 19.968-48.128t48.64-19.456l437.248 0zM187.392 389.12q28.672 0 48.64 19.968t19.968 48.64l0 52.224q0 27.648-19.968 47.616t-48.64 19.968l-54.272 0q-27.648 0-47.616-19.968t-19.968-47.616l0-52.224q0-28.672 19.968-48.64t47.616-19.968l54.272 0zM889.856 389.12q27.648 0 47.616 19.968t19.968 48.64l0 52.224q0 27.648-19.968 47.616t-47.616 19.968l-437.248 0q-28.672 0-48.64-19.968t-19.968-47.616l0-52.224q0-28.672 19.968-48.64t48.64-19.968l437.248 0zM187.392 708.608q28.672 0 48.64 19.968t19.968 47.616l0 52.224q0 28.672-19.968 48.64t-48.64 19.968l-54.272 0q-27.648 0-47.616-19.968t-19.968-48.64l0-52.224q0-27.648 19.968-47.616t47.616-19.968l54.272 0zM889.856 708.608q27.648 0 47.616 19.968t19.968 47.616l0 52.224q0 28.672-19.968 48.64t-47.616 19.968l-437.248 0q-28.672 0-48.64-19.968t-19.968-48.64l0-52.224q0-27.648 19.968-47.616t48.64-19.968l437.248 0z"
                ></path>
              </svg>
            </em>
          </div>
        </div>
      </div>

      <div class="audit-btns ghost-button-styles" v-if="materialTabName === IMAGE_TYPES.AI_REMIX">
        <el-radio-group v-model="remixImageType" @change="initQueryAction">
          <el-radio-button v-for="v in REMIX_VIDEO_STAGE_LIST" :key="v.value" ghost :label="v.value">
            {{ v.label }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <Viewport v-loading="loading" v-model="gridHeight">
        <material-info-table
          v-if="listType"
          ref="materialInfoTable"
          :columns="tableCol"
          :data="materialData"
          :type="materialTabName"
          :table-height="tableHeight()"
          @sort-change="onTableSort"
          @checkbox-all="selectAll(!isCheckAll)"
          @selection-change="selectionChange"
          @header-dragend="headerDragend"
        >
          <p slot="videoDesc" slot-scope="{ row }" v-html="videoDescFormatter(row.videoDesc)"></p>

          <template #videoClips="{ row }">
            <p v-if="!row.videoClips">-</p>

            <template v-else>
              <p v-html="videoDescFormatter(row.videoClips)"></p>
            </template>
          </template>
        </material-info-table>
        <div v-else :style="{ height: tableHeight() }" style="overflow-y: auto">
          <div class="similar-search-alert" v-if="isSimilarSearch">
            <el-alert title="正在搜索相似的视频" type="info" :description="`检索内容条件：${queryFormKeyword}`" show-icon> </el-alert>
          </div>
          <material-table
            ref="materialTable"
            :data="materialData"
            :type="materialTabName"
            @on-check="selectItem"
            @on-select="selectMaterial"
            @find-similar="findSimilar"
          />
        </div>
      </Viewport>

      <el-pagination
        style="text-align: right"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :page-sizes="[24, 48, 64]"
        :total="total"
        @current-change="changePageIndex"
        @size-change="changePageSize"
      >
      </el-pagination>
    </div>
    <!-- 审核 -->
    <AuditModal :visible.sync="auditModal" :id-list="idList" :audit-type="auditType" @audit-finished="onAuditFinished"> </AuditModal>

    <!-- 入库 -->
    <el-dialog :visible.sync="showSentToLibModal" :close-on-click-modal="false" :show-close="false" title="审核入库" width="460px">
      <ElForm label-width="130px">
        <ElFormItem label="视频">
          <span>已选择{{ idList.length }}个视频</span>
        </ElFormItem>

        <ElFormItem label="说明"> 入库成功后将进入正式投放</ElFormItem>
      </ElForm>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="showSentToLibModal = false">取消</el-button>
          <el-button type="primary" :loading="onLibLoading" @click="onLibSubmit"> 确定 </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 批量弹窗 -->
    <BatchActionsModal
      v-model="batchActionModal"
      :loading="updateLoading"
      :idList="idList"
      :materialIds="materialIds"
      :formItem="formItem"
      :type="batchType"
      :imageType="materialTabName"
      @on-cancel="batchActionModal = false"
      @on-edit="batchEdit"
      @on-limit="limitMedia"
    >
    </BatchActionsModal>

    <MaterialDetailsModal
      v-model="materialDetailModal"
      :formItem="materiaItem"
      :loading="detailLoading"
      :imageType="materialTabName"
      @on-upload="uploadMaterial"
      @on-upload-base="uploadBase64"
      @refresh="selectMaterial"
    />
    <edit-video-modal v-model="editVideoModal" :material-data="selectItemList" @on-cancel="clearAll" />

    <!-- 导入结果弹窗 :table-data="success_d" :update-total="updated" -->
    <resulter
      v-model="resultModel"
      type="素材人员绑定"
      down-fail
      :req="req"
      :add-total="added"
      :fail-total="failure"
      @on-close="resultOk"
      @on-down="downFailData"
    />
  </div>
</template>
<script>
import { HOST_API } from '@/api/config'
import { Message } from 'view-design'
import { isArray } from '@/common/js/utils'
import { MEDIAS_LIST } from '@/common/js/constants'
import { datetimeToDay, datetimeToSec } from '@/common/js/filters'
import DEFAULT_COLS, { NAVS } from './table-cols.js'
import tableMixin from './mixin_table'
import { IMAGE_TYPES_STR_VAL as IMAGE_TYPES, IMAGE_STYLE } from '@/views/material/uploading/consts.js'
import { REJECT_REASONS, REMIX_VIDEO_STAGE_LIST, BATCH_COMMANDS_ENUM, SEARCH_TYPE } from './const.js'

import LibraryFilter from './components/lib-filter.vue'
import MaterialTable from './components/material-table.vue'
import MaterialInfoTable from './components/material-info-table.vue'
import BatchActionsModal from './components/batch-modal.vue'
import MaterialDetailsModal from './components/material-modal.vue'
import EditVideoModal from './components/edit-video-modal.vue'
import Resulter from '@/components/export/result-dialog'
import AuditModal from './components/audit-modal.vue'
import CustomColumnDropdownBtn from '@/components/custom-column-v2/dropdown-btn.vue'
import {
  queryImageByPage,
  batchDeleteMaterial,
  setImageExcludeMedia,
  queryImageDetailById,
  batchUpdateImageInfo,
  replaceImageDetail,
  uploadGrabImage,
  importImageOperatorExcel,
  abVideosSentToLib,
  abVideoRetrySubTask
} from '@/api/material.model'
import { getTagByIds } from '@/api/manage.model'

const getDefaultFormItem = () => {
  return {
    imageName: '',
    imageDetailName: '',
    designerId: [],
    plannerId: [],
    imageStyles: [],
    tagGroups: [],
    labelIds: [],
    videoLabelIds: [],
    imageLauchTime: '',
    game: [],
    excludeMediaIds: []
  }
}

export default {
  name: 'LibraryMain',
  mixins: [tableMixin],
  components: {
    LibraryFilter,
    MaterialInfoTable,
    MaterialTable,
    BatchActionsModal,
    MaterialDetailsModal,
    AuditModal,
    EditVideoModal,
    Resulter,
    CustomColumnDropdownBtn
  },
  computed: {
    defaultTableColNavs() {
      return NAVS
    },
    defaultTableCols() {
      return DEFAULT_COLS
    },
    tableCol() {
      return [].concat(this.tableColumns.filter((ret) => ret.checked))
    },
    REMIX_VIDEO_STAGE_LIST() {
      return REMIX_VIDEO_STAGE_LIST
    },
    BATCH_COMMANDS_ENUM() {
      return BATCH_COMMANDS_ENUM
    },
    permissions() {
      return {
        authDelete: this.access.includes('M20853'),
        authEdit: this.access.includes('M20854'),
        authLimit: this.access.includes('M20855'),
        authImportDownload: this.access.includes('M20856'),
        authAudit: this.access.includes('M21215')
      }
    },
    idList() {
      // 所选子素材id列表
      return this.selectItemList.map((ret) => ret.id)
    },
    materialIds() {
      // 所选母素材imageId列表
      return [...new Set(this.selectItemList.map((ret) => ret.imageId))] // 去重
    },
    materialPermissions() {
      const { VIDEO, IMAGE, STICKERS, GROUP_IMAGE, META, AI_REMIX, REMIX_AUDIT_DENY, PLAYABLE } = IMAGE_TYPES

      let remove = false

      if (this.materialTabName !== AI_REMIX) {
        remove = this.permissions.authDelete
      } else {
        remove = ![IMAGE_TYPES.REMIX_AUDIT_PRE, IMAGE_TYPES.REMIX_AUDIT_PASS].includes(this.remixImageType)
      }
      return {
        // 允许视频、图片、组图、贴纸 编辑
        edit: [VIDEO, IMAGE, GROUP_IMAGE, STICKERS, META, PLAYABLE].includes(this.materialTabName) && this.permissions.authEdit,

        // AI混剪待审核、待入库不允许删除，其他的类型可以删除
        remove,
        // 允许视频、图片、组图 设置限制媒体投放
        limit: [VIDEO, IMAGE, GROUP_IMAGE].includes(this.materialTabName) && this.permissions.authLimit,
        // 只允许ai混剪审核被拒的类型可以重新生成
        redo: AI_REMIX === this.materialTabName && REMIX_AUDIT_DENY === this.remixImageType
      }
    }
  },
  watch: {
    // 素材类型
    materialTabName(nVal) {
      this.initQueryAction()
    }
  },
  data() {
    return {
      gridHeight: 330,
      queryFormKeyword: '',
      isCheckAll: false,
      params: {},
      loading: null,
      onLibLoading: false,
      updateLoading: null,
      detailLoading: null,
      resultModel: null,
      auditModal: false,
      listType: false,
      IMAGE_TYPES,

      added: 0,
      failure: 0,
      req: null,

      metaSources: [],
      groupGames: [],
      auditType: '',
      remixImageType: IMAGE_TYPES.REMIX_AUDIT_PRE,
      materialTabName: IMAGE_TYPES.VIDEO,
      formItem: { ...getDefaultFormItem() }, // 批量修改项
      materiaItem: {}, // 详情项
      batchType: null, // 批量弹窗类型
      showSentToLibModal: false,
      batchActionModal: false, // 批量弹窗
      materialDetailModal: false, // 素材详情弹窗
      editVideoModal: false, // 批量视频编辑
      selectItemList: [],
      materialData: [], // 素材数据
      access: this.$store.state.accessAuth,
      isSimilarSearch: false,
      tableColumns: [],
      toggleTableColLoading: false
    }
  },
  methods: {
    getData(showLoading = true) {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order,

        ...this.$refs.filterRef.buildParams()
      }

      this.queryFormKeyword = params.keyword
      this.isSimilarSearch = params.similarSearch
      const { imageType, ...restParams } = params

      if (this.materialTabName === IMAGE_TYPES.AI_REMIX) {
        restParams.imageType = this.remixImageType
      } else {
        restParams.imageType = this.materialTabName
      }
      if (this.loading) return

      if (showLoading) {
        this.loading = true
      }
      // 每次加载表格数据时，清空表格数据否则组件内部素材显示的el-popover会定位不准
      if (this.listType) this.materialData = []
      queryImageByPage(restParams)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.materialData = list.map((item) => {
                let rejectReasonIdsName = ''
                if (item.rejectReasonIds) {
                  rejectReasonIdsName = REJECT_REASONS.filter((reason) =>
                    item.rejectReasonIds.split(',').map(Number).includes(reason.value)
                  )
                    .map((reason) => reason.label)
                    .join('、')
                }
                return {
                  ...item,
                  check: !!this.idList.includes(item.id),
                  rejectReasonIdsName
                }
              })
              this.total = total_number || 0
              this.isCheckAll = !!(
                this.materialData.filter((ret) => ret.check).length === this.materialData.length && this.materialData.length
              )
              this.$nextTick(() => {
                // 兼容popover 定位不准问题
                document.documentElement.click()
              })
            } else {
              this.materialData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.materialData = []
          this.total = 0
        })
    },
    findSimilar({ aiContent }) {
      if (aiContent) {
        try {
          const aiContentJSON = JSON.parse(aiContent)
          if (aiContentJSON?.video_desc) {
            this.$refs.filterRef.onScriptFindSimilar(aiContentJSON.video_desc)
          } else {
            console.log('findSimilar error: ', 'video_desc is not exist')
          }
        } catch (error) {
          console.log('aiContentJSON error: ', error)
        }
      } else {
        console.log('findSimilar error: ', 'aiContent is not exist')
      }
    },
    onAuditFinished() {
      this.getData()
      this.selectItemList = []
    },
    initQueryAction() {
      this.pageIndex = 1
      this.selectItemList = []
      this.isCheckAll = false
      this.selectAll(this.isCheckAll)
      this.getData()
    },
    selectItem(item) {
      const { check, id } = item
      const existIndex = this.idList.findIndex((ret) => ret === id)
      if (check) existIndex === -1 && this.selectItemList.push(item)
      else {
        this.selectItemList.splice(existIndex, 1)
      }
      this.isCheckAll = this.materialData.filter((ret) => ret.check).length === this.materialData.length
    },
    clearAll() {
      this.isCheckAll = false
      this.materialData.forEach((ret) => {
        ret.check = false
        if (this.listType) {
          this.$refs.materialInfoTable.toggleRowSelection(ret, false)
        }
      })
      this.selectItemList = []
    },
    videoDescFormatter(videoDesc) {
      let { queryFormKeyword } = this
      queryFormKeyword = queryFormKeyword.trim()
      if (!videoDesc) return '-'
      if (!queryFormKeyword) return videoDesc
      const textRegexp = new RegExp(queryFormKeyword, 'gi')
      let highlightText = videoDesc
      let match
      // 循环匹配所有关键词出现的位置
      while ((match = textRegexp.exec(videoDesc)) !== null) {
        const matchedText = match[0]
        // 将匹配到的实际文本用红色高亮包裹
        highlightText = highlightText.replace(matchedText, `<strong style='color:red'>${matchedText}</strong>`)
      }
      return highlightText
    },
    getDetailMaterial(id) {
      this.detailLoading = true
      this.materialDetailModal = true

      queryImageDetailById({ id: id })
        .then((data) => {
          this.detailLoading = false
          if (data) {
            const { lauchTime, size, createTime } = data
            this.materiaItem = {
              ...data,
              size: size ? (size / (1024 * 1024)).toFixed(2) : '',
              imageLauchTime: lauchTime ? datetimeToSec(lauchTime) : '',
              createTime: datetimeToSec(createTime) || ''
            }
          } else {
            this.materialDetailModal = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.materiaItem = {}
        })
    },

    selectMaterial(id) {
      this.getDetailMaterial(id)
    },
    selectionChange(selection) {
      this.selectItemList = [...selection]
    },
    onTableSort({ order, prop }) {
      this.sort = prop
      this.order = order
      this.pageIndex = 1
      this.getData()
    },
    selectAll(check) {
      this.materialData.length &&
        this.materialData.forEach((ret) => {
          this.$set(ret, 'check', check)
          this.selectItem(ret)
          if (this.listType) {
            this.$refs.materialInfoTable.toggleRowSelection(ret, check)
          }
        })
      if (!this.materialData.length) {
        this.isCheckAll = false
        this.selectItemList = []
      }
    },
    onAuditAction(type) {
      this.auditModal = true
      this.auditType = type
    },
    onLibSubmit() {
      this.onLibLoading = true
      abVideosSentToLib({ imageDetailIds: this.idList })
        .then((data) => {
          if (data) {
            this.showSentToLibModal = false
            this.$Message.success('操作成功')
            this.getData(false)
          }
        })
        .finally(() => {
          this.onLibLoading = false
        })
    },
    async batchAction(type) {
      this.batchType = type
      if (!this.idList.length) {
        this.$Message.warning({
          duration: 5,
          content: '当前未选中任何素材，请在列表中选择一个或多个素材再进行此操作。'
        })
      } else if (type === BATCH_COMMANDS_ENUM.REDO) {
        this.$confirm(`是否将${this.idList.length}个素材进行任务重试？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          abVideoRetrySubTask({ childMaterialIds: this.idList }).then((data) => {
            if (data) {
              this.$Message.success('操作成功！')
              this.getData()
            }
          })
        })
      } else if (type === BATCH_COMMANDS_ENUM.EDIT || type === BATCH_COMMANDS_ENUM.LIMIT) {
        if (this.materialIds.length === 1) {
          // 只有唯一母素材
          try {
            const materialItem = await queryImageDetailById({ id: this.idList[0] })
            if (materialItem) {
              const {
                imageName,
                designerId,
                plannerId,
                // imageStyles,
                imageStyle1LabelIds,
                imageStyle2LabelIds,
                labelIds,
                videoLabelIds,
                lauchTime,
                gameIds,
                excludeMediaIds,
                imageDetailName
              } = materialItem

              const list = gameIds
                ?.split(',')
                .map(Number)
                .filter((ret) => ret)

              let imageStylesModel = [] // 素材样式级联model
              if (imageStyle2LabelIds) {
                const imageStyleTag = await getTagByIds({ labelIdStr: imageStyle2LabelIds })
                if (imageStyleTag?.length) {
                  imageStylesModel = imageStyleTag.map((tag) => tag.labelPath)
                }
              }

              this.formItem = {
                imageName: imageName || '',
                imageDetailName: this.idList.length === 1 && imageDetailName ? imageDetailName : '',
                designerId,
                plannerId: plannerId ? plannerId.split(',').map(Number) : [],
                imageStyles: imageStylesModel,
                tagGroups: [],
                labelIds: labelIds ? labelIds.split(',').map(Number) : [],
                videoLabelIds: videoLabelIds ? videoLabelIds.split(',').map(Number) : [],
                imageLauchTime: lauchTime ? datetimeToDay(lauchTime) : '',
                game: gameIds ? list : [],
                // 20260107 修改为默认全选
                excludeMediaIds: excludeMediaIds ? excludeMediaIds.split(',').map(Number) : MEDIAS_LIST.map((media) => media.value)
              }
              this.batchActionModal = true
            }
          } catch (e) {
            console.log('queryImageDetailById error output: ', e)
          }
        } else {
          // 有多个母素材
          this.formItem = {
            ...getDefaultFormItem(),
            // 20260107 修改为默认全选
            excludeMediaIds: MEDIAS_LIST.map((media) => media.value)
          }
          this.batchActionModal = true
        }
      } else {
        // type === BATCH_COMMANDS_ENUM.REMOVE
        this.$confirm(`已选${this.idList.length}个素材，删除后不可恢复，是否继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteMaterial()
        })
      }
    },
    batchEdit(formItem) {
      const {
        imageName,
        game,
        designerId,
        plannerId,
        labelIds,
        imageStyles,
        imageLauchTime,
        imageDetailName,
        videoLabelIds = []
      } = formItem

      const threedLabels = videoLabelIds || []
      const imageStyle = []
      const imageStyle2 = []

      imageStyles.forEach((s) => {
        const [parentId, childId] = s
        imageStyle.push(parentId)
        if (childId) imageStyle2.push(childId)
      })

      const params = {
        imageName: imageName,
        imageDetailName: imageDetailName,
        imageIds: this.materialIds.join(','),
        detailIds: this.idList.join(','),
        gameIds: game ? game.join(',') : [],
        designerId,
        imageStyle: 0,
        plannerId: plannerId ? plannerId.join(',') : [],
        labelIds: [labelIds, imageStyle, imageStyle2, threedLabels]
          .filter((i) => Array.isArray(i))
          .flat()
          .join(','),
        imageLauchTime
      }
      this.batchActionModal = false
      this.loading = true
      batchUpdateImageInfo(params)
        .then((data) => {
          if (data) {
            this.$Message.success('修改成功')

            this.initQueryAction()
          } else {
            this.$Message.error('修改失败')
          }
        })
        .catch((err) => {
          this.$Message.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteMaterial() {
      batchDeleteMaterial({ imageDetailIds: this.idList.join(',') })
        .then((data) => {
          if (data) {
            this.$Message.success('删除成功')
            this.initQueryAction()
          } else {
            this.loading = false
            this.$Message.error('删除失败')
          }
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    limitMedia(ids) {
      const params = {
        detailIds: this.idList.join(','),
        excludeMediaIds: ids.join(',')
      }
      setImageExcludeMedia(params)
        .then((data) => {
          if (data) {
            this.$Message.success('操作成功！')
            this.getData()
            this.selectItemList = []
          } else {
            this.$Message.error('操作失败！')
          }
        })
        .catch(() => {
          console.log('error')
        })
      this.batchActionModal = false
    },
    uploadMaterial(file, type, detailId) {
      if (type === 6) type = 7 // 替换音频封面：7 替换音频：6
      this.detailLoading = true
      replaceImageDetail({ file, type, detailId })
        .then((data) => {
          this.detailLoading = false
          if (data) {
            this.getDetailMaterial(detailId)
            this.materialData = []
            this.getData(false)
            this.$Message.success('替换成功！')
          } else this.$Message.error('替换失败！')
        })
        .catch(() => console.log('error'))
    },
    uploadBase64(data, detailId) {
      this.detailLoading = true
      uploadGrabImage({ imageDetailId: detailId, cutImageBase64: data })
        .then((data) => {
          this.detailLoading = false
          if (data) this.getDetailMaterial(detailId)
        })
        .catch(() => {
          this.detailLoading = false
          this.$Message.error('截图封面上传失败！')
        })
    },
    headerDragend(n, o, column) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    },
    async onTableColsChange(cols) {
      this.toggleTableColLoading = true
      await new Promise((resolve) => {
        setTimeout(resolve, 100)
      })
      this.tableColumns = cols
      this.toggleTableColLoading = false
    },
    preUpload(file) {
      this.importExcel(file)
      return false
    },
    importExcel(file) {
      this.$Spin.show()
      importImageOperatorExcel({ file }).then((data) => {
        this.$Spin.hide()
        if (data) {
          this.resultModel = true
          this.added = data.successTotal
          this.failure = data.failTotal
          this.req = data.requestId
        }
      })
    },
    resultOk() {
      this.resultModel = false
      this.initQueryAction()
    },
    downFailData(req) {
      window.open(`${HOST_API}/api/ptom/imageInfo/downloadError?requestId=${req}`, '_blank')
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_ptom_image_operator`, '_blank')
    },
    preloadData() {
      this.getData()
    },
    changeList() {
      this.listType = !this.listType
      if (this.materialData.length) {
        this.$nextTick(() => {
          this.materialData.forEach((ret) => {
            if (this.listType) {
              this.$refs.materialInfoTable.toggleRowSelection(ret, ret.check)
            } else {
              this.$set(ret, 'check', ret.check)
            }
          })
        })
      }
    },
    tableHeight() {
      if (this.materialTabName === IMAGE_TYPES.AI_REMIX) return this.gridHeight - 40 - 36 + 'px'
      return this.gridHeight - 36 - 6 + 'px'
    }
  },
  mounted() {
    this.preloadData()
  },
  filters: {
    toStrThousands(cell) {
      const res = cell.replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ','
        })
      })
      return res
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';
.similar-search-alert {
  margin-bottom: 10px;
  border-radius: 4px;
  ::v-deep .el-alert {
    background-color: #eff7ff;
    padding: 4px 16px;
    color: #0d5dd7;
    .el-alert__description {
      color: #1878ff;
    }
  }
}
.table-wrapper {
  .tab-row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    ::v-deep .el-tabs {
      .el-tabs__header {
        margin-bottom: 6px;
      }
    }

    .table-operation-row {
      flex: 1;
      padding-left: 20px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding-bottom: 1px;
      // margin-bottom: -5px;
      border-bottom: 2px solid #dfe4ed;
      .left-btns {
        display: flex;
        align-items: center;
      }
      .right-btns {
        display: flex;
        align-items: center;

        .template-download-icon {
          font-size: 18px;
          cursor: pointer;
          margin-right: 6px;
        }

        .toggle-view-btn {
          display: flex;
          cursor: pointer;
          padding: 4px;
          border-radius: 4px;
          margin-left: 3px;
          background: #a9a9a9;
          &.active {
            background: #1974ff;
          }
        }
      }
    }
  }

  .audit-btns {
    margin-bottom: 6px;
  }
}
</style>
